import { Badge, Grid, HStack, Skeleton, Text, VStack } from "@chakra-ui/react"
import StatusIndicator from "components/StatusIndicator"
import { riskColor, riskLabel } from "enums/labelRisks"
import dateFormat from "functions/dateFormat"
import { findLastMetricInAssessmentsByTag } from "functions/lives/metrics"
import { Life } from "interfaces/life"

interface Props {
    life: Life
    isLoading: boolean
}

const LifeDetails = ({ life, isLoading }: Props) => {
    let decodedJson = !life.integration_identifiers ? '' : JSON.parse(life?.integration_identifiers);
    let cpf = decodedJson[0]?.cpf || '';
    // let risk = findLastMetricInAssessmentsByTag(life?.assessments || [], 'risco_gestacional');

    return (
        <VStack spacing={3} w="full" alignItems="flex-start">
            {/* <VStack spacing={1} alignItems="flex-start">
                <Text fontSize="md">ID</Text>
                {
                    isLoading ?
                        <Skeleton h="27px" w="full" />
                    :
                        <Text fontSize="lg">{life.id}</Text>
                }
            </VStack> */}
            <VStack spacing={1} alignItems="flex-start">
                <Text fontSize="md" fontWeight="bold">Nome completo</Text>
                {
                    isLoading ?
                        <Skeleton h="27px" w="full" />
                    :
                        <Text fontSize="lg">{life.name}</Text>
                }
            </VStack>
            <VStack spacing={1} alignItems="flex-start">
                <Text fontSize="md" fontWeight="bold">Status</Text>
                    {
                        isLoading ?
                            <Skeleton h="27px" w="full" />
                        :
                            <StatusIndicator isActive={life.programs.length > 0 ? true : false} />
                    }
            </VStack>
            <Grid
                w="full"
                templateColumns={{ sm: "1fr", md: "repeat(2, 1fr)" }}
                gap="24px"
                mb="24px"
            >
                <VStack spacing={1} alignItems="flex-start">
                    <Text fontSize="md" fontWeight="bold">Nº Carteirinha</Text>
                    {
                        isLoading ?
                            <Skeleton h="27px" w="full" />
                        :
                            <Text fontSize="lg">{life.document}</Text>
                    }
                </VStack>
                <VStack spacing={1} alignItems="flex-start">
                    <Text fontSize="md" fontWeight="bold">CPF</Text>
                    {
                        isLoading ?
                            <Skeleton h="27px" w="full" />
                        :
                            <Text fontSize="lg">{cpf}</Text>
                    }
                </VStack>
                <VStack spacing={1} alignItems="flex-start">
                    <Text fontSize="md" fontWeight="bold">Data de Nascimento</Text>
                    {
                        isLoading ?
                            <Skeleton h="27px" w="full" />
                        :
                            <Text fontSize="lg">{dateFormat(life.birthdate)}</Text>
                    }
                </VStack>
                <VStack spacing={1} alignItems="flex-start">
                    <Text fontSize="md" fontWeight="bold">Telefone</Text>
                    {
                        isLoading ?
                            <Skeleton h="27px" w="full" />
                        :
                            <Text fontSize="lg">{life.phone}</Text>
                    }
                </VStack>
                <VStack spacing={1} alignItems="flex-start">
                    <Text fontSize="md" fontWeight="bold">Data de criação</Text>
                    {
                        isLoading ?
                            <Skeleton h="27px" w="full" />
                        :
                            <Text fontSize="lg">{dateFormat(life.created_at)}</Text>
                    }
                </VStack>
            </Grid>
            <VStack spacing={1} alignItems="flex-start">
                <HStack spacing={4} justifyContent="space-between">
                </HStack>
            </VStack>
        </VStack>
    )
}

export default LifeDetails